import { render, staticRenderFns } from "./addCase.vue?vue&type=template&id=ca7fea9a&scoped=true&"
import script from "./addCase.vue?vue&type=script&lang=js&"
export * from "./addCase.vue?vue&type=script&lang=js&"
import style0 from "./addCase.vue?vue&type=style&index=0&id=ca7fea9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7fea9a",
  null
  
)

export default component.exports